import { render, staticRenderFns } from "./ProjectTemplate6.vue?vue&type=template&id=3d5c60a2&scoped=true"
import script from "./ProjectTemplate6.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate6.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate6.vue?vue&type=style&index=0&id=3d5c60a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c60a2",
  null
  
)

export default component.exports